const BackgroundCircleForLogo = () => {
    return (
        <svg width="160" height="161" viewBox="0 0 160 161" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.2" filter="url(#filter0_f_706_7406)">
                <ellipse cx="80" cy="80.5" rx="60" ry="60" fill="#FDD7FF"/>
            </g>
            <defs>
                <filter id="filter0_f_706_7406" x="0" y="0.5" width="160" height="160" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur stdDeviation="10" result="effect1_foregroundBlur_706_7406"/>
                </filter>
            </defs>
        </svg>

    );
}

export default BackgroundCircleForLogo;
